export default "__VITE_PUBLIC_ASSET__f2ef2adb__"